import React from 'react';
import { useTranslation } from 'react-i18next';

export default () => {
    const { t } = useTranslation();
    return (
        <>
            <p>Hi this is SystemCategory.Home</p>
            <p>{t('US.COLLECTION.ADMIN:SYSTEMCATEGORY.TEST')}</p>
        </>
    )
}